import Vue from 'vue'
import messageConfig from './messageBox.vue'

function messageBox(msg,call,btnTxt) {
    let messageBoxTpl = Vue.extend(messageConfig);
    let messageBoxPro = new messageBoxTpl({
        el:document.createElement('div')
    });
    document.body.appendChild(messageBoxPro.$el);
    messageBoxPro.$watch('messageBoxShow',function (val) {
        if(!val){
            messageBoxPro.$destroy(true);
            messageBoxPro.$el.parentNode.removeChild(messageBoxPro.$el)
        }
    });
    messageBoxPro.message = msg;
    messageBoxPro.btnText = btnTxt;
    messageBoxPro.messageBoxShow = true;
    messageBoxPro.callBack = call;
}
export default messageBox



// WEBPACK FOOTER //
// ./src/components/messageBox/messageBox.js